import { render, staticRenderFns } from "./ChapterSelect.vue?vue&type=template&id=0b9f7fc8&scoped=true&"
import script from "./ChapterSelect.vue?vue&type=script&lang=ts&"
export * from "./ChapterSelect.vue?vue&type=script&lang=ts&"
import style0 from "./ChapterSelect.vue?vue&type=style&index=0&id=0b9f7fc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9f7fc8",
  null
  
)

export default component.exports